// extracted by mini-css-extract-plugin
export default {"mainCad":"Genero_mainCad__QdRHc","cinetec":"Genero_cinetec__RHxKr","formCadGen":"Genero_formCadGen__jdF9H","inputGen":"Genero_inputGen__y0KhH","btnGen":"Genero_btnGen__jvWZk"};